__turbopack_context__.v({
  "languageLabel": "PartnerDetails-module-scss-module__sRVuJa__languageLabel",
  "locationLabel": "PartnerDetails-module-scss-module__sRVuJa__locationLabel",
});
